import * as React from 'react';

import {Loading} from '@common/react/components/UI/Loading/Loading';
import {List} from '@common/typescript/objects/List';

import AreaHeader from '@app/components/UI/Area-blocks/AreaHeader/AreaHeader';
import MiddleText from '@app/components/UI/MiddleText/MiddleText';
import SliderAreaVetCarousel from '@app/components/UI/Slider/SliderAreaVetCarousel';
import {rest} from '@app/components/Api';
import {Veterinarian} from '@app/objects/Veterinarian';

const AreaVets = (props) => {
	const {area} = props;
	const areaId = area.id;

	const [vets, setVets] = React.useState<Veterinarian[]>([]);

	React.useEffect(() => {
		rest.get<List<Veterinarian>>(`v1/areas/${areaId}/veterinarians`)
			.then((res) => {
				setVets(res.list);
			});
	}, []);

	if (!vets) {
		return <Loading />;
	}

	return (
		<div className="area">
			<AreaHeader area={area}/>
			
			<MiddleText title={'Meet the veterinarians'}>
				<SliderAreaVetCarousel sliderItems={vets} />
			</MiddleText>
		</div>
	);
};

export default AreaVets;
